import React from 'react';

import HomeButton from 'components/HomeButton';

function Header() {
  return (
    <div className="p-l-l p-t-m">
      <HomeButton />
    </div>
  );
}

export default Header;
